<template>

  <div>
    <table class="table __type__hrz __type__input">
      <tbody>
          <tr>
              <th class="wdt-120em">上代</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__sm text-right" v-model=" answer.retail_price " required>
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>下代</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__sm text-right" v-model=" answer.wholesale_price" required >
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>原価</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__sm text-right" v-model=" answer.cost" required>
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>資材・キャンドル</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__sm text-right" v-model=" answer.material_price">
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>磨き・レンタル代</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__sm text-right" v-model=" answer.rental_price">
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>生花仕入代（計）</th>
              <td>
                  <p class="form-row">
                      {{ total }}
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>花材</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__full" placeholder="名称" v-model=" answer.item1">
                  </p>
                  <p class="form-row price-train-item-form">
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="単価" v-model=" answer.price1"></span>
                      <span class="__unit__sub-text form-text">円</span>
                      <span class="__unit__sub-text form-text">×</span>
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="本数" v-model=" answer.unit1"></span>
                      <span class="__unit__sub-text form-text">本</span>
                      <span class="__unit__sub-text form-text">＝</span>
                      <span class="__unit__value">{{ subtotal1 }}</span>
                      <span class="__unit__sub-text form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>花材</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__full" placeholder="名称" v-model=" answer.item2">
                  </p>
                  <p class="form-row price-train-item-form">
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="単価" v-model=" answer.price2"></span>
                      <span class="__unit__sub-text form-text">円</span>
                      <span class="__unit__sub-text form-text">×</span>
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="本数" v-model=" answer.unit2"></span>
                      <span class="__unit__sub-text form-text">本</span>
                      <span class="__unit__sub-text form-text">＝</span>
                      <span class="__unit__value">{{ subtotal2 }}</span>
                      <span class="__unit__sub-text form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>花材</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__full" placeholder="名称" v-model=" answer.item3">
                  </p>
                  <p class="form-row price-train-item-form">
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="単価" v-model=" answer.price3"></span>
                      <span class="__unit__sub-text form-text">円</span>
                      <span class="__unit__sub-text form-text">×</span>
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="本数" v-model=" answer.unit3"></span>
                      <span class="__unit__sub-text form-text">本</span>
                      <span class="__unit__sub-text form-text">＝</span>
                      <span class="__unit__value">{{ subtotal3 }}</span>
                      <span class="__unit__sub-text form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>花材</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__full" placeholder="名称" v-model=" answer.item4 ">
                  </p>
                  <p class="form-row price-train-item-form">
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="単価" v-model=" answer.price4"></span>
                      <span class="__unit__sub-text form-text">円</span>
                      <span class="__unit__sub-text form-text">×</span>
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="本数" v-model=" answer.unit4"></span>
                      <span class="__unit__sub-text form-text">本</span>
                      <span class="__unit__sub-text form-text">＝</span>
                      <span class="__unit__value">{{ subtotal4 }}</span>
                      <span class="__unit__sub-text form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>花材</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__full" placeholder="名称" v-model=" answer.item5 ">
                  </p>
                  <p class="form-row price-train-item-form">
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="単価" v-model=" answer.price5"></span>
                      <span class="__unit__sub-text form-text">円</span>
                      <span class="__unit__sub-text form-text">×</span>
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="本数" v-model=" answer.unit5"></span>
                      <span class="__unit__sub-text form-text">本</span>
                      <span class="__unit__sub-text form-text">＝</span>
                      <span class="__unit__value">{{ subtotal5 }}</span>
                      <span class="__unit__sub-text form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>花材</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__full" placeholder="名称" v-model=" answer.item6 ">
                  </p>
                  <p class="form-row price-train-item-form">
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="単価" v-model=" answer.price6"></span>
                      <span class="__unit__sub-text form-text">円</span>
                      <span class="__unit__sub-text form-text">×</span>
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="本数" v-model=" answer.unit6"></span>
                      <span class="__unit__sub-text form-text">本</span>
                      <span class="__unit__sub-text form-text">＝</span>
                      <span class="__unit__value">{{ subtotal6 }}</span>
                      <span class="__unit__sub-text form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>花材</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__full" placeholder="名称" v-model=" answer.item7 ">
                  </p>
                  <p class="form-row price-train-item-form">
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="単価" v-model=" answer.price7"></span>
                      <span class="__unit__sub-text form-text">円</span>
                      <span class="__unit__sub-text form-text">×</span>
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="本数" v-model=" answer.unit7"></span>
                      <span class="__unit__sub-text form-text">本</span>
                      <span class="__unit__sub-text form-text">＝</span>
                      <span class="__unit__value">{{ subtotal7 }}</span>
                      <span class="__unit__sub-text form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>花材</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__full" placeholder="名称" v-model=" answer.item8 ">
                  </p>
                  <p class="form-row price-train-item-form">
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="単価" v-model=" answer.price8"></span>
                      <span class="__unit__sub-text form-text">円</span>
                      <span class="__unit__sub-text form-text">×</span>
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="本数" v-model=" answer.unit8"></span>
                      <span class="__unit__sub-text form-text">本</span>
                      <span class="__unit__sub-text form-text">＝</span>
                      <span class="__unit__value">{{ subtotal8 }}</span>
                      <span class="__unit__sub-text form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>花材</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__full" placeholder="名称" v-model=" answer.item9 ">
                  </p>
                  <p class="form-row price-train-item-form">
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="単価" v-model=" answer.price9"></span>
                      <span class="__unit__sub-text form-text">円</span>
                      <span class="__unit__sub-text form-text">×</span>
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="本数" v-model=" answer.unit9"></span>
                      <span class="__unit__sub-text form-text">本</span>
                      <span class="__unit__sub-text form-text">＝</span>
                      <span class="__unit__value">{{ subtotal9 }}</span>
                      <span class="__unit__sub-text form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>花材</th>
              <td>
                  <p class="form-row">
                      <input type="text" class="form-control __size__full" placeholder="名称" v-model=" answer.item10 ">
                  </p>
                  <p class="form-row price-train-item-form">
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="単価" v-model=" answer.price10"></span>
                      <span class="__unit__sub-text form-text">円</span>
                      <span class="__unit__sub-text form-text">×</span>
                      <span class="__unit__value"><input type="text" class="form-control __size__xs text-right" placeholder="本数" v-model=" answer.unit10"></span>
                      <span class="__unit__sub-text form-text">本</span>
                      <span class="__unit__sub-text form-text">＝</span>
                      <span class="__unit__value">{{ subtotal10 }}</span>
                      <span class="__unit__sub-text form-text">円</span>
                  </p>
              </td>
          </tr>
      </tbody>
    </table>

    <ul class="list-button">
      <li><button type="submit" class="button __type__save"  @click="save()">回答する</button></li>
    </ul>

    <!-- use the modal component, pass in the prop -->
    <modal v-if="showModal && resultMessage" @close="showModal = false">
      <div v-if="resultMessage" slot="body" class="modal" style="display:block;">
        <p style="white-space: pre-wrap;" v-text="resultMessage"></p>
        <ul class="list-button">
          <li>
            <button class="button __type__delete" v-on:click="showModal = false">閉じる</button>
          </li>
        </ul>
      </div>
    </modal>
    <modal v-if="showModal && !resultMessage">
    </modal>

    <modal_base></modal_base>

  </div>
</template>

<script>
  Vue.component( 'modal', {template: '#modal-template'});
  import moment from 'moment';

  export default {
    components: {
    },
    props: {
      answer: {type: Object},
    },

    data() {
      return {
        input: this.answer,
        resultMessage: '',
        showModal: false,
      }
    },

    created(){
    },

    mounted() {
      this.answer.retail_price = this.numberFormat(this.answer.retail_price);
      this.answer.wholesale_price = this.numberFormat(this.answer.wholesale_price);
      this.answer.cost = this.numberFormat(this.answer.cost);
      this.answer.material_price = this.numberFormat(this.answer.material_price);
      this.answer.rental_price = this.numberFormat(this.answer.rental_price);
      this.answer.price1 = this.numberFormat(this.answer.price1);
      this.answer.unit1 = this.numberFormat(this.answer.unit1);
      this.answer.price2 = this.numberFormat(this.answer.price2);
      this.answer.unit2 = this.numberFormat(this.answer.unit2);
      this.answer.price3 = this.numberFormat(this.answer.price3);
      this.answer.unit3 = this.numberFormat(this.answer.unit3);
      this.answer.price4 = this.numberFormat(this.answer.price4);
      this.answer.unit4 = this.numberFormat(this.answer.unit4);
      this.answer.price5 = this.numberFormat(this.answer.price5);
      this.answer.unit5 = this.numberFormat(this.answer.unit5);
      this.answer.price6 = this.numberFormat(this.answer.price6);
      this.answer.unit6 = this.numberFormat(this.answer.unit6);
      this.answer.price7 = this.numberFormat(this.answer.price7);
      this.answer.unit7 = this.numberFormat(this.answer.unit7);
      this.answer.price8 = this.numberFormat(this.answer.price8);
      this.answer.unit8 = this.numberFormat(this.answer.unit8);
      this.answer.price9 = this.numberFormat(this.answer.price9);
      this.answer.unit9 = this.numberFormat(this.answer.unit9);
      this.answer.price10 = this.numberFormat(this.answer.price10);
      this.answer.unit10 = this.numberFormat(this.answer.unit10);
    },

    filters: {
    },

    computed: {
      subtotal1: function(){
        var price = (this.input.price1 + '' || '').replace(/,/g, '');
        var unit = (this.input.unit1 + '' || '').replace(/,/g, '');
        return this.subtotal(price, unit);
      },
      subtotal2: function(){
        var price = (this.input.price2 + '' || '').replace(/,/g, '');
        var unit = (this.input.unit2 + '' || '').replace(/,/g, '');
        return this.subtotal(price, unit);
      },
      subtotal3: function(){
        var price = (this.input.price3 + '' || '').replace(/,/g, '');
        var unit = (this.input.unit3 + '' || '').replace(/,/g, '');
        return this.subtotal(price, unit);
      },
      subtotal4: function(){
        var price = (this.input.price4 + '' || '').replace(/,/g, '');
        var unit = (this.input.unit4 + '' || '').replace(/,/g, '');
        return this.subtotal(price, unit);
      },
      subtotal5: function(){
        var price = (this.input.price5 + '' || '').replace(/,/g, '');
        var unit = (this.input.unit5 + '' || '').replace(/,/g, '');
        return this.subtotal(price, unit);
      },
      subtotal6: function(){
        var price = (this.input.price6 + '' || '').replace(/,/g, '');
        var unit = (this.input.unit6 + '' || '').replace(/,/g, '');
        return this.subtotal(price, unit);
      },
      subtotal7: function(){
        var price = (this.input.price7 + '' || '').replace(/,/g, '');
        var unit = (this.input.unit7 + '' || '').replace(/,/g, '');
        return this.subtotal(price, unit);
      },
      subtotal8: function(){
        var price = (this.input.price8 + '' || '').replace(/,/g, '');
        var unit = (this.input.unit8 + '' || '').replace(/,/g, '');
        return this.subtotal(price, unit);
      },
      subtotal9: function(){
        var price = (this.input.price9 + '' || '').replace(/,/g, '');
        var unit = (this.input.unit9 + '' || '').replace(/,/g, '');
        return this.subtotal(price, unit);
      },
      subtotal10: function(){
        var price = (this.input.price10 + '' || '').replace(/,/g, '');
        var unit = (this.input.unit10 + '' || '').replace(/,/g, '');
        return this.subtotal(price, unit);
      },
      total: function(){
        var ret =0;
        for(let i=1; i < 11; i++){
          ret += parseInt((eval('this.subtotal' + i)+'').replace(/,/g, '')) || 0;
        }
        console.log(ret);
        return ret.toLocaleString() || 0;
      },
    },

    watch: {
      'answer.retail_price': function (val, old) {
        this.answer.retail_price = this.numberFormat(val);
      },
      'answer.wholesale_price': function (val, old) {
        this.answer.wholesale_price = this.numberFormat(val);
      },
      'answer.cost': function (val, old) {
        this.answer.cost = this.numberFormat(val);
      },
      'answer.material_price': function (val, old) {
        this.answer.material_price = this.numberFormat(val);
      },
      'answer.rental_price': function (val, old) {
        this.answer.rental_price = this.numberFormat(val);
      },
      'answer.price1': function (val, old) {
        this.answer.price1 = this.numberFormat(val);
      },
      'answer.unit1': function (val, old) {
        this.answer.unit1 = this.numberFormat(val);
      },
      'answer.price2': function (val, old) {
        this.answer.price2 = this.numberFormat(val);
      },
      'answer.unit2': function (val, old) {
        this.answer.unit2 = this.numberFormat(val);
      },
      'answer.price3': function (val, old) {
        this.answer.price3 = this.numberFormat(val);
      },
      'answer.unit3': function (val, old) {
        this.answer.unit3 = this.numberFormat(val);
      },
      'answer.price4': function (val, old) {
        this.answer.price4 = this.numberFormat(val);
      },
      'answer.unit4': function (val, old) {
        this.answer.unit4 = this.numberFormat(val);
      },
      'answer.price5': function (val, old) {
        this.answer.price5 = this.numberFormat(val);
      },
      'answer.unit5': function (val, old) {
        this.answer.unit5 = this.numberFormat(val);
      },
      'answer.price6': function (val, old) {
        this.answer.price6 = this.numberFormat(val);
      },
      'answer.unit6': function (val, old) {
        this.answer.unit6 = this.numberFormat(val);
      },
      'answer.price7': function (val, old) {
        this.answer.price7 = this.numberFormat(val);
      },
      'answer.unit7': function (val, old) {
        this.answer.unit7 = this.numberFormat(val);
      },
      'answer.price8': function (val, old) {
        this.answer.price8 = this.numberFormat(val);
      },
      'answer.unit8': function (val, old) {
        this.answer.unit8 = this.numberFormat(val);
      },
      'answer.price9': function (val, old) {
        this.answer.price9 = this.numberFormat(val);
      },
      'answer.unit9': function (val, old) {
        this.answer.unit9 = this.numberFormat(val);
      },
      'answer.price10': function (val, old) {
        this.answer.price10 = this.numberFormat(val);
      },
      'answer.unit10': function (val, old) {
        this.answer.unit10 = this.numberFormat(val);
      },
    },

    methods: {
      subtotal(price, unit){
        if(!price || !unit || price.match(/[^0-9]+/) || unit.match(/[^0-9]+/)){
          return '';
        }
        return (parseInt(price) * parseInt(unit)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      numberFormat(val){
        if(val == undefined) return '';
        var price = (val+'').replace(/,/g, '');
        if(!price || price.match(/[^0-9]+/)){
          return val;
        }
        return parseInt(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },

      save(){
        if(this.showModal) return;

        this.showModal = true;
        this.resultMessage = '';
        axios.post('/api/price/' + this.input.user_id + '/' + this.input.pricecheck_id ,{
          'answer': this.answer,
        }).then(res => {
          this.resultMessage = res.data.message || '更新しました。';
          this.showModal = 'updated';
        }).catch(error => {
          let message = "";
          for (var key in error.response.data.errors) {
            for (let v of error.response.data.errors[key]){
              message += v + "\n";
            }
          }
          this.resultMessage = message || error.response.data.message || 'エラーが発生しました。';
          this.showModal = 'canceled';
        });
      }

    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Pricecheck.vue